import Vue from 'vue'
import Router from 'vue-router'
import Register from '@/page/Register'
import Contract from '@/page/ContractInfo'
import Card from '@/page/CardInfo'
import Booking from '@/page/Booking'
import DiabetesCalculator from '@/page/DiabetesCalculator'
import Auth from '@/page/Auth'
import Login from '@/page/Login'
import Home from '@/page/Home'

import Apply from '@/page/Apply'
import CardUpdate from '@/page/CardUpdate'
import RevisitContract from '@/page/RevisitContract'
import CompleteRevisitBooking from '@/page/CompleteRevisitBooking'
import CalculateSaveFileView from '@/page/CalculateSaveFileView'
import MedicalInfo from '@/page/MedicalInfo';
import Settlement from '@/page/Settlement'

import PharmacyMap from '@/page/Pharmacy';
import PharmacyDetail from '@/page/PharmacyDetail'
import Uncomfortable from '@/page/pc_uncomfortable/Uncomfortable';
import Rankings from '@/page/pc_uncomfortable/Rankings'
import List from '@/components/organisms/map/List'
import Improvement from '@/page/pc_uncomfortable/Improvement'
import MUncomfortable from '@/page/m_uncomfortable/Uncomfortable'
import MRankings from '@/page/m_uncomfortable/Rankings'
import MImprovement from '@/page/m_uncomfortable/Improvement'
import Address from '@/page/Address';
import Invite from '@/page/Invite';

import Test from '@/page/Test'
import ContractBack from '@/components/atoms/ContractBack'

import NewHome from '@/page/new/Home'
import NewInvite from '@/page/new/Invite'


import RareDiseaseCalc from '@/page/RareDiseaseCalc'
import CatheterCalc from '@/page/CatheterCalc'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/test',
      name: 'test',
      component: NewHome
    },
    {
      path: '/m/campaign',
      name: 'mobile_uncomfortable',
      component: MUncomfortable,
      children: [
        {
          path: 'ranking',
          name: 'ranking',
          component: MRankings
        },
        {
          path: 'improvement',
          name: 'improvement',
          component: MImprovement
        }
      ]
    },
    {
      path: '/campaign',
      name: 'uncomfortable',
      component: Uncomfortable,
      children: [
        {
          path: 'ranking',
          name: 'ranking',
          component: Rankings
        },
        {
          path: 'improvement',
          name: 'improvement',
          component: Improvement
        }
      ]
    },
    {
      path: '/pharmacy-map',
      name: 'pharmacy-map',
      component: PharmacyMap
    },
    {
      path:'/info',
      name: 'info',
      component: MedicalInfo
    },
    {
      path: '/settlement',
      name: 'settlement',
      component: Settlement
    },
    {
      path: '/save',
      name: 'save',
      component: CalculateSaveFileView
    },
    {
      path: '/auth/callback',
      name: 'auth',
      component: Auth
    },
    {
      path: '/home',
      name: 'Home',
      component: NewHome
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/apply',
      name: 'Apply',
      component: Apply
    },
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/contract',
      name: 'contract',
      component: Contract
    },
    {
      path: '/revisit',
      name: 'revisitcontract',
      component: RevisitContract
    },
    {
      path: '/complete',
      name: 'complete',
      component: CompleteRevisitBooking
    },
    {
      path: '/card',
      name: 'card',
      component: Card
    },
    {
      path: '/cardupdate',
      name: 'card',
      component: CardUpdate
    },
    {
      path: '/address',
      name: 'address',
      component: Address
    },
    {
      path: '/invite',
      name: 'invite',
      component: NewInvite
    },
    {
      path: '/booking',
      name: 'booking',
      component: Booking
    },
    {
      path: '/calc',
      name: 'calc',
      component: DiabetesCalculator
    },
    // {
    //   path: '/rare-disease-calc',
    //   name: 'rare-disease-calc',
    //   component: RareDiseaseCalc,
    // },
    {
      path: '/catheter-calc',
      name: 'catheter-calc',
      component: CatheterCalc,
    },
    {
      path: '/detail/:pharmacyId',
      name: 'detail',
      component: PharmacyDetail
    },
    {
      path: '/test',
      name: 'ContractTest',
      component: ContractBack
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js